import React, { useContext, useEffect } from 'react';
import { Marker, useMap, useMapEvents } from 'react-leaflet';

import { CreateMeetingContext } from '../../../../services/create-meeting/create-meeting.context';

export const Markers = () => {
  const { states } = useContext(CreateMeetingContext);
  const { location, setLocation } = states;
  const meetingMap = useMap();
  useEffect(() => {
    location &&
      location.lat &&
      location.lng &&
      meetingMap.setView(
        { lat: location.lat, lng: location.lng },
        meetingMap.getZoom()
      );
  }, [location, meetingMap]);

  const map = useMapEvents({
    click: (e) => {
      map.setView(e.latlng, map.getZoom());
      setLocation(e.latlng);
    },
  });

  return <>{location && <Marker position={location} />}</>;
};
